var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-list"},_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,staticClass:"customer-list_item"},[_c('img',{attrs:{"src":item,"loading":"lazy"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }